<div class="footer hide-sm">
    <div class="row justify-content-center align-items-center">
        <div class="col-6">
            <div class="text-left">
                <a href="/terms" target="blank">{{labels.privacyPolicy}}</a>
                <a href="/terms" target="blank">{{labels.termsAndConditions}}</a>
            </div>
        </div>
        <div class="col-6">
            <div class="text-right">
                <p>&copy; {{currentYear}},{{labels.footerCopyright}}</p>
            </div>
        </div>
    </div>
</div>